import { useProjectMeta } from "modules/project/hooks/useMeta"
import { useMetricProjectAvailability } from "./useMetricProjectAvailability"

/**
 * Returns a list of available metric ids for a project.
 * e.g. https://api.tokenterminal.com/v3/internal/projects/aave/metric-availability
 * @example
 * const { data: availableMetricIds } = useAvailableMetricIdsQuery("aave")
 */

export const useAvailableMetricIdsForProject = (
  projectSlug: string,
  productId?: string
) => {
  const projectMeta = useProjectMeta(projectSlug)
  const { data, ...rest } = useMetricProjectAvailability({
    dataIds: projectMeta ? [projectMeta.data_id] : [],
    productIds: productId ? [productId] : undefined,
  })
  return {
    data: data?.data.map((metric) => metric.metric_id) || [],
  }
}
